import {getCDP} from '@app/modules/tracking/cdp';
import {useCallback, useState} from 'react';
import {getClientAuthInstance} from '@app/modules/auth/client';
import {useAutolog} from './auth/useAutolog';
import {useApiCall} from '@deezer/react-legacy-api';

let logoutInProgress = false;

export const isLogoutInProgress = () => logoutInProgress;
export const markLogoutInProgress = () => {
	logoutInProgress = true;
};
export const resetLogoutInProgress = () => {
	logoutInProgress = false;
};

export const useLogout = () => {
	const {mutate} = useAutolog();
	const apiCall = useApiCall();
	const [isLoading, setLoading] = useState(false);

	const logout = useCallback(
		async (redirectPath = '/') => {
			if (isLoading) return;
			setLoading(true);
			markLogoutInProgress();

			try {
				await Promise.allSettled([
					apiCall({method: 'deezer_userLogout'}),
					getClientAuthInstance().logout(),
				]);
				await mutate();
				getCDP().logout();
			} catch {
				resetLogoutInProgress();
				return;
			}

			if (typeof window !== 'undefined') {
				window.location.href = redirectPath;
				return;
			}

			resetLogoutInProgress();
		},
		[mutate, apiCall, isLoading],
	);
	return {isLoading, logout};
};
